/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_CityInputs */



/**
* | output |
* | --- |
* | "City" |
*
* @param {Common_CityInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const common_city = /** @type {((inputs?: Common_CityInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_CityInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ville")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ciudad")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Cidade")
	if (locale === "it") return /** @type {LocalizedString} */ ("Città")
	return /** @type {LocalizedString} */ ("City")
});